export default __webpack_public_path__ + "static/media/worker.77d27db2.png";